import React, { useEffect, useState } from 'react';
import styles from './DocumentNode.module.scss';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import DocumentModal from './document-modal/DocumentModal';
const DocumentNode = ({ id, selected }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(node?.is_Error || false);

  const media = node?.media;
  const isEmpty =
    node?.media == undefined ||
    (media?.uploadedFile == '' &&
      media?.url == '' &&
      (media?.fileName == '' || media?.fileName == undefined));
  const isURL = media?.isURL == false && media?.url !== '';

  useEffect(() => {
    if (node?.media) {
      if (isEmpty) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.media]);
  return (
    <>
      <NodeContainer
        name={node?.title ?? 'Document Block'}
        id={id}
        onClick={() => setIsModalOpen(true)}
        backgroundColor={node?.color}
        selected={selected}
        node={node}
        isError={isError}
      >
        <Handle
          type="target"
          position={Position.Left}
          className="custom-handle"
        />

        {isEmpty ? (
          <div className={styles.document}>
            <SvgWithBranding type="document" color="#787878" />
            <div className={styles.text}>
              <p>Document</p>
              <span>Upload a document (doc,pdf,xls)</span>
            </div>
          </div>
        ) : (
          <div className={styles.document}>
            <SvgWithBranding type="node-file" />
            <div className={styles.text}>
              <p>
                {node?.media?.uploadedFile?.name ||
                  node?.media?.file?.fileName ||
                  node?.media?.fileName ||
                  'Document'}
              </p>
              <span>Document</span>
            </div>
          </div>
        )}

        <Handle
          type="source"
          position={Position.Right}
          className="custom-handle"
        />
      </NodeContainer>
      <DocumentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Document"
        id={id}
        node={node}
        allowedExtensions={[
          'doc',
          'docx',
          'pdf',
          'xls',
          'xlsx',
          'ppt',
          'pptx',
          'txt',
        ]}
        isError={isError}
      />
    </>
  );
};

export default DocumentNode;
